import { Injectable } from '@angular/core';
import { CacheService } from '@delon/cache';

interface BridgeData {
  displayThousandsSep: boolean;
}

/**
 * 逻辑优化
 */
@Injectable({
  providedIn: 'root',
})
export class BridgeService {
  displayThousandsSep = !!this.cache.getNone('hostex_price_display_thousands_sep');

  constructor(private cache: CacheService) {}

  updateBridgeData(data: BridgeData) {
    Object.assign(this, data);

    this.cache.set('hostex_price_display_thousands_sep', data.displayThousandsSep);
  }

  // updateDisplayThousandsSep(display: boolean) {
  //   this.displayThousandsSep = display;
  //   this.cache.set('hostex_price_display_thousands_sep', display);
  // }
}
